var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validate',_vm._g({attrs:{"validations":"required","validated-value":_vm.signature}},_vm.$listeners),[_c('signature',{attrs:{"height":"145px"},on:{"signed":_vm.setSignature}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }